import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  selectParkingVouchers,
  parkingVouchersCreating,
  parkingVouchersLoaded,
  parkingVouchersMeta,
  parkingVouchersFilters
} from "../../../../redux/parkingVouchers/selectors";
import Confirm from "../../../../base/Confirm";
import { selectVenues } from "../../../../redux/venues/selectors";
import ListView from "../../../../base/ListView";
import { dateRender } from "../../../../libs/utils";
import { PARKING_VOUCHERS_ACTIONS } from "../../../../redux/parkingVouchers/actions";
import VouchersHeader from "./VouchersHeader";
import { getParkings } from "../../../../services/api/parkings";

class _ParkingVouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parkingVouchers: this.props.parkingVouchers,
      parkingVouchersLoaded: this.props.parkingVouchersLoaded,
      filters: this.props.filters,
      defaultFilters: {
        "page[number]": 1,
        "page[size]": 10,
        sort: "-updated_at",
        "filter[event_id]": this.props.event.id,
        include: "parking"
      }
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    parkingVouchers: PropTypes.array,
    parkingVouchersLoaded: PropTypes.bool,
    loadParkingVouchers: PropTypes.func,
    createParkingVoucher: PropTypes.func,
    updateParkingVoucher: PropTypes.func,
    deleteParkingVoucher: PropTypes.func,
    venues: PropTypes.array,
    match: PropTypes.object,
    parkingVoucherMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    this.props.updateFilters(this.state.defaultFilters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {
      parkingVouchers: nextProps.parkingVouchers,
      parkingVouchersLoaded: nextProps.parkingVouchersLoaded
    };

    this.setState(newState);
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleCreate(values) {
    const data = {
      name: values.name
    };
    this.props.createParkingVoucher(data);
  }

  _handleUpdate(values) {
    const data = {
      name: values.name
    };

    this.props.updateParkingVoucher(values.id, data);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this parkingVoucher? This action can not be undone, please make sure no festival is using this parkingVoucher.",
      {
        title: "Delete ParkingVoucher",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteParkingVoucher(id);
      },
      result => {}
    );
  }

  render() {
    const { parkingVoucherMeta, filters, event } = this.props;
    const { parkingVouchers, parkingVouchersLoaded } = this.state;

    const listViewConf = {
      dataSet: parkingVouchers,
      dataMeta: parkingVoucherMeta,
      columns: [
        {
          key: "parking.name",
          value: "Parking"
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          render: parkingVoucher => dateRender(parkingVoucher.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Parking",
          icon: "la-car",
          type: "typeahead",
          options: value =>
            getParkings({
              "filter[name]": value,
              "filter[event_id]": event.id
            }),
          key: "parking_id",
          labelKey: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/events/" + event.id + "/vouchers/parking"
    };

    return (
      <div>
        <VouchersHeader event={event} />
        {parkingVouchersLoaded && (
          <ListView
            config={listViewConf}
            handleFilterUpdate={this._handleFilterUpdate}
            keepPadding
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadParkingVouchers: () =>
    dispatch(PARKING_VOUCHERS_ACTIONS.loadAllRequest()),
  createParkingVoucher: values =>
    dispatch(PARKING_VOUCHERS_ACTIONS.createRequest(values)),
  updateParkingVoucher: (id, values) =>
    dispatch(PARKING_VOUCHERS_ACTIONS.updateRequest(id, values)),
  deleteParkingVoucher: id =>
    dispatch(PARKING_VOUCHERS_ACTIONS.deleteRequest(id)),
  updateFilters: filters =>
    dispatch(PARKING_VOUCHERS_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    venues: selectVenues(state),
    parkingVouchers: selectParkingVouchers(state),
    parkingVoucherMeta: parkingVouchersMeta(state),
    parkingVouchersLoaded: parkingVouchersLoaded(state),
    parkingVoucherCreating: parkingVouchersCreating(state),
    filters: parkingVouchersFilters(state)
  };
};

const ParkingVouchers = connect(
  mapStateToProps,
  mapDispatchToProps
)(_ParkingVouchers);

export default ParkingVouchers;
